var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { 
// eslint-disable-next-line no-restricted-imports
useMutation as originalUseMutation, } from '@tanstack/react-query';
import useWrappedNetworkFunction from '../error/useWrappedNetworkFunction.js';
/**
 * Wrapper for useMutation with error checking
 *
 * Refer to https://tanstack.com/query/latest/docs/react/reference/useMutation for usage
 *
 * @param options see useMutation
 */
const useMutation = (_a) => {
    var { mutationFn, onException } = _a, opts = __rest(_a, ["mutationFn", "onException"]);
    return originalUseMutation(Object.assign({ mutationFn: useWrappedNetworkFunction(mutationFn, onException) }, opts));
};
export default useMutation;
//# sourceMappingURL=useMutation.js.map